/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sec_Pg_P2_TInputs */

const en_mk_sec_pg_p2_t = /** @type {(inputs: Mk_Sec_Pg_P2_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An agent has no rights of its own`)
};

const id_mk_sec_pg_p2_t = /** @type {(inputs: Mk_Sec_Pg_P2_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agen tidak punya hak sendiri`)
};

/**
* | output |
* | --- |
* | "An agent has no rights of its own" |
*
* @param {Mk_Sec_Pg_P2_TInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sec_pg_p2_t = /** @type {((inputs?: Mk_Sec_Pg_P2_TInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sec_Pg_P2_TInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sec_pg_p2_t(inputs)
	return en_mk_sec_pg_p2_t(inputs)
});